import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import RichText from '~/components/ui/RichText.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockImageTextListStandard',
  components: {
    RichText: RichText,
    AzImg: AzImg
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLast: Boolean
  },
  setup: function setup(props) {
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var isFullWidth = inject('isFullWidth', false);
    var isInTabSection = inject('isInTabSection', false);
    var isInPageAdvice = inject('isInPageAdvice', false);
    var getItemDisplayOptions = function getItemDisplayOptions(item) {
      var section = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'container';
      if (!item.displayOptions) return;
      var itemClasses = useGetDisplayOptionsClasses(item.displayOptions);
      return itemClasses[section];
    };
    var getImageUrl = function getImageUrl(item) {
      var _item$image;
      return (item === null || item === void 0 ? void 0 : (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) || null;
    };
    var getBackgroundImageStyle = function getBackgroundImageStyle(item) {
      if (!(item !== null && item !== void 0 && item.displayOptions)) return;
      var images = item.displayOptions.find(function (option) {
        var _option$fields;
        return option === null || option === void 0 ? void 0 : (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : _option$fields.images;
      });
      if (images) {
        var _images$fields, _images$fields$images, _images$fields$images2, _images$fields$images3;
        return {
          background: "no-repeat center url(".concat(images === null || images === void 0 ? void 0 : (_images$fields = images.fields) === null || _images$fields === void 0 ? void 0 : (_images$fields$images = _images$fields.images[0]) === null || _images$fields$images === void 0 ? void 0 : (_images$fields$images2 = _images$fields$images.fields) === null || _images$fields$images2 === void 0 ? void 0 : (_images$fields$images3 = _images$fields$images2.file) === null || _images$fields$images3 === void 0 ? void 0 : _images$fields$images3.url, ")")
        };
      }
    };
    var areClassesEmpty = computed(function () {
      return Object.keys(classes).length === 0;
    });
    return {
      getImageUrl: getImageUrl,
      getItemDisplayOptions: getItemDisplayOptions,
      getBackgroundImageStyle: getBackgroundImageStyle,
      classes: classes,
      isFullWidth: isFullWidth,
      isInTabSection: isInTabSection,
      isInPageAdvice: isInPageAdvice,
      areClassesEmpty: areClassesEmpty
    };
  }
});